import { clientapi } from './api-clients/client-api.js';
import Cookie from 'js-cookie';

export function clearAuthCookies() {
    clearUserAuthCookies();
    clearAdminAuthCookies();
}

export function clearUserAuthCookies() {
    Cookie.remove( 'access_token' );
    Cookie.remove( 'refresh_token' );
}

export function clearAdminAuthCookies() {
    Cookie.remove( 'admin_access_token' );
    Cookie.remove( 'admin_refresh_token' );
}

function getLoginPathWithRedirectParam() {
    const loginURL = new URL( window.location.origin + '/' );

    let next = '';

    if ( window.location.pathname && window.location.pathname.length > 0 ) {
        next = window.location.pathname;
    }

    if ( next !== '' && window.location.search && window.location.search.length > 0 ) {
        next += window.location.search;
    }

    if ( next !== '' ) {
        loginURL.searchParams.set( 'redirect', encodeURIComponent( next ) );
    }

    return loginURL.toString();
}

export function getAdminUser() {
    const token = Cookie.get( 'admin_access_token' );

    if ( !token ) {
        clearAuthCookies();

        if ( window.location.pathname !== '/' ) {
            window.location.href = getLoginPathWithRedirectParam();
        }

        return null;
    }

    return getUserFromToken( token );
}

export function getUser() {
    const logout = ()=> {
        clearAuthCookies();

        if ( window.location.pathname !== '/' ) {
            window.location.href = getLoginPathWithRedirectParam();
        }
    };

    const token = Cookie.get( 'access_token' );

    if ( !token ) {
        logout();
        return null;
    }

    const user = getUserFromToken( token );

    if ( !user ) {
        logout();
        return null;
    }

    return user;
}

export function onBeforeOpenSwal() {
    ( document.activeElement as HTMLElement ).blur();

    window.setTimeout( ()=> {
        ( document.activeElement as HTMLElement ).blur();
    }, 1000 );
}

// https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
function parseJwt( token: string ) {
    // check if token is valid
    if ( !token || token.split( '.' ).length < 2 ) {
        return null;
    }

    const base64Url = token.split( '.' )[ 1 ];
    const base64 = base64Url.replace( /-/g, '+' ).replace( /_/g, '/' );
    const jsonPayload = decodeURIComponent( atob( base64 ).split( '' ).map( function( c ) {
        return '%' + ( '00' + c.charCodeAt( 0 ).toString( 16 ) ).slice( -2 );
    } ).join( '' ) );

    return JSON.parse( jsonPayload );
}

export function checkIfEmail( text: string ) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( text );
}

export function getAdmin() {
    const accessToken = Cookie.get( 'admin_access_token' );

    if ( !accessToken ) {
        return null;
    }

    return parseJwt( accessToken )[ 'user' ];
}

export function getUserFromToken( accessToken: string ) {
    const jwt = parseJwt( accessToken );

    if ( !jwt || !jwt.user ) {
        return null;
    }

    return jwt.user;
}

export async function getPropertyService() {
    const result = await clientapi.get( '/services/property' );

    if ( result.status === 200 ) {
        return result.data;
    }

    return {
        Status: 'NOT_ACTIVE',
        PropertyLimit: 0,
    };
}

export async function getFeaturedService() {
    const result = await clientapi.get( '/services/featured' );

    if ( result.status === 200 ) {
        return result.data;
    }

    return {
        MaxFeaturedStandard: 0,
        MaxFeaturedPremium: 0,
    };
}
